import { render, staticRenderFns } from "./VerkaufBlock.vue?vue&type=template&id=5c56846d&"
import script from "./VerkaufBlock.vue?vue&type=script&lang=js&"
export * from "./VerkaufBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports